export default "/_next/static/images/422ac24eecd6707c965de3562c0675e3.png";